<template>
  <div>
    <v-navigation-drawer
      :model-value="modelValue"
      @update:model-value="$emit('update:modelValue', $event)"
      temporary
      style="padding-bottom: var(--footer-height, 0px)"
    >
      <v-list nav density="compact">
        <v-list-item>
          <v-list-item-title class="text-title-large"> Panneau d'administration </v-list-item-title>
        </v-list-item>
        <v-divider></v-divider>
        <v-list-item :to="{ name: 'admin-sections' }" prepend-icon="mdi-map-search" title="Sections"></v-list-item>
        <v-list-item :to="{ name: 'admin-gauge-list' }" prepend-icon="mdi-gauge" title="Stations"></v-list-item>
        <v-list-item :to="{ name: 'admin-camera-list' }" prepend-icon="mdi-webcam" title="Caméras"></v-list-item>
        <v-list-item
          :to="{ name: 'admin-partner-list' }"
          prepend-icon="mdi-handshake-outline"
          title="Partenaires"
        ></v-list-item>
        <v-list-item
          :to="{ name: 'admin-danger-flags' }"
          prepend-icon="mdi-flag-outline"
          title="Dangers signalés"
        ></v-list-item>
        <v-divider class="border-warning border-opacity-100 mt-2"></v-divider>
        <v-list-item :to="{ name: 'admin-user-list' }" prepend-icon="mdi-account-group" title="Utilisateurs"></v-list-item>
        <v-list-item v-if="isImpersonating" @click="$emit('restore-admin-session')">
          <template #prepend>
            <v-icon color="warning">mdi-account-arrow-left</v-icon>
          </template>
          <v-list-item-title class="text-warning">Revenir à l'admin</v-list-item-title>
        </v-list-item>
        <v-list-item
          v-else
          prepend-icon="mdi-account-switch"
          title="Se connecter comme un utilisateur"
          @click="openImpersonationDialog"
        ></v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-dialog v-model="showImpersonationDialog" max-width="560">
      <v-card>
        <v-card-title class="text-headline-small">Connexion comme utilisateur</v-card-title>
        <v-card-text>
          <p class="mb-3">Entrez l'UID du compte à tester.</p>
          <v-text-field
            v-model="targetUid"
            label="UID utilisateur"
            hint="Ex: 75oIWh0AToRR49j8XqmgSuS6trI3"
            persistent-hint
          ></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn variant="text" @click="closeImpersonationDialog">Annuler</v-btn>
          <v-btn color="primary" @click="submitImpersonation">Se connecter</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  export default {
    name: "AdminNavigationDrawer",
    props: {
      modelValue: {
        type: Boolean,
        default: false,
      },
      isImpersonating: {
        type: Boolean,
        default: false,
      },
    },
    emits: ["update:modelValue", "restore-admin-session", "request-impersonation"],
    data() {
      return {
        showImpersonationDialog: false,
        targetUid: "",
      };
    },
    methods: {
      openImpersonationDialog() {
        this.showImpersonationDialog = true;
      },
      closeImpersonationDialog() {
        this.showImpersonationDialog = false;
        this.targetUid = "";
      },
      submitImpersonation() {
        this.$emit("request-impersonation", this.targetUid);
        this.closeImpersonationDialog();
      },
    },
  };
</script>
